import { OpenFeature } from '@openfeature/react-sdk';

import { FEATURE_FLAG_DOMAIN } from '@/features/flags/constants';

/**
 * Killswitch for section normalization of pasted content in the vMarkdown
 * editor. OFF (default): a pasted `<h1>` survives sanitization and
 * `normalizePastedSections` turns it into a section, matching what the
 * plain-text flavor of the same copy already produces. ON: break-glass — the
 * sanitizer unwraps every heading again and the paste transform is skipped,
 * restoring the pre-fix behavior where an HTML paste drops the section title.
 *
 * Both halves are read from this one flag on purpose. Keeping `<h1>` without
 * the transform would leave a bare top-level heading rendered at full document
 * heading size — the defect this fix removes — so a partial revert would be
 * worse than either whole state.
 *
 * Called outside React (a ProseMirror plugin prop), so non-hook only.
 *
 * Lives in this standalone `.ts` module (not the `index.tsx` barrel) so the
 * reader does not add a `react-refresh/only-export-components` warning to the
 * component barrel. Import it directly from
 * `@/features/flags/paste-section-normalize-flag`.
 */
export const isPasteSectionNormalizeKilled = () => {
  return OpenFeature.getClient(FEATURE_FLAG_DOMAIN).getBooleanValue(
    'op-scribe-disable-paste-section-normalize',
    false
  );
};
